import React, { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import { useNavigate } from "react-router-dom";

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .min(1, "Name must be atleast 1 character")
    .required("Name is required"),
  type: Yup.string().required("Type is required"),
});

const AddVariablePopup = ({ toggleAddVariablePopup, addVariable }) => {
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  return (
    <>
      <div className="absolute left-0 top-0 w-screen h-screen z-50 backdrop-blur-sm flex justify-center items-center">
        <div className="z-50 my-4 text-base list-none text-black bg-white divide-y divide-gray-100 rounded-md shadow-lg w-[20em] text-left p-4 border border-slate-300">
          <div className="">
            <Formik
              initialValues={{
                name: "",
                type: "string",
              }}
              validationSchema={validationSchema}
              onSubmit={(values) => {
                setMsg("");
                setLoading(true);

                addVariable(values.name, values.type).then(() => {
                  setLoading(false);
                  toggleAddVariablePopup();
                });
              }}>
              {({ errors, touched, values }) => (
                <Form className="space-y-4">
                  <div>
                    <label
                      htmlFor="name"
                      className="block text-sm font-medium text-gray-700">
                      <span className="text-red-500">*</span>Name
                    </label>
                    <Field
                      name="name"
                      type="text"
                      className={
                        "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" +
                        (errors.name && touched.name ? " border-red-500" : "")
                      }
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />

                    <label
                      htmlFor="type"
                      className="block text-sm font-medium text-gray-700">
                      <span className="text-red-500">*</span>Type
                    </label>
                    <Field
                      as="select"
                      name="type"
                      className={
                        "mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" +
                        (errors.type && touched.type ? " border-red-500" : "")
                      }>
                      <option value="string">String</option>
                      {/* <option value="integer">Integer</option> */}
                    </Field>
                    <ErrorMessage
                      name="type"
                      component="div"
                      className="text-red-500 text-sm mt-1"
                    />
                  </div>

                  <div className="w-full mt-4 flex gap-2 justify-center z-30">
                    <button
                      type="submit"
                      className={`border-[1px] rounded text-white  px-5 py-[6px]   ${
                        loading
                          ? "bg-gray-300 text-slate-600"
                          : "bg-black border-black"
                      }`}
                      disabled={loading}>
                      Add
                    </button>
                    <button
                      onClick={toggleAddVariablePopup}
                      type="button"
                      className={`border-[1px] rounded text-white  px-5 py-[6px] bg-black border-black `}>
                      Cancel
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddVariablePopup;
